import { AnalyticsContext } from '@shared/contexts/AnalyticsContext';
import { useMeContext } from '@shared/contexts/hooks/useMeContext';
import { useEmailThreadContext } from '@shared/contexts/pluginContexts/EmailThreadContext';
import { useTrackedMovementsForExternalThreadQuery } from '@shared/generated/graphql';
import { useOrganizationFeatureFlag } from '@shared/hooks/useOrganizationFeatureFlag';
import { FeatureFlagName } from 'clerk_common/types';
import { useContext } from 'react';

export const useThreadTrackedMovements = () => {
  const { defaultOrgId } = useMeContext();
  const { thisItem } = useEmailThreadContext();
  const { apiClient } = useContext(AnalyticsContext);
  const mayTrackLoad = useOrganizationFeatureFlag({
    featureFlagName: FeatureFlagName.TRACK_LOADS_IN_SIDEKICK,
  });

  const { data, loading, refetch } = useTrackedMovementsForExternalThreadQuery({
    variables: {
      input: {
        apiClient,
        organizationId: defaultOrgId,
        externalIdentifiers: thisItem?.id ? [thisItem.id] : [],
      },
    },
    skip: !thisItem?.id || !mayTrackLoad,
  });

  return {
    movements: data?.trackedMovementsForExternalThread ?? [],
    loading,
    refetch,
  };
};
